export default {
    subscriptionProductSku: 'Cookie_Magic_Mo',
    freeDoughProCookie: '1172'
}
